const orderPay = () => import('@/views/main/order/pay/pay.vue')
export default {
  path: '/main/order/orderPay',
  name: 'orderPay',
  component: orderPay,
  children: []
}
